import { render, staticRenderFns } from "./TaxDeclarationSummary.vue?vue&type=template&id=b9222440&scoped=true"
import script from "./TaxDeclarationSummary.vue?vue&type=script&lang=js"
export * from "./TaxDeclarationSummary.vue?vue&type=script&lang=js"
import style0 from "./TaxDeclarationSummary.vue?vue&type=style&index=0&id=b9222440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9222440",
  null
  
)

export default component.exports